import React from 'react';
import ProductDraw from 'assets/svgs/product-draw.svg';
import { useIsMobile } from 'hooks/useIsMobile';
import styles from '../ExistingSiteStoreReadyStep.scss';

export function PanelIconPlaceholder() {
  const isMobile = useIsMobile();

  if (isMobile) {
    return null;
  }

  return (
    <div className={styles.existingSiteStoreReadyPanelIllustration} aria-hidden>
      <ProductDraw />
    </div>
  );
}
